import {useContext} from 'preact/hooks';

import {ShadowRootContext} from 'utilities/dom';

export function useMountStrategyName() {
  const shadowRoot = useContext(ShadowRootContext);
  return shadowRoot?.host.getAttribute('data-strategy');
}

export function useThemeOverride() {
  const shadowRoot = useContext(ShadowRootContext);
  return shadowRoot?.host.getAttribute('data-theme');
}
